export default __webpack_public_path__ + "static/media/service-6.2538d10d.svg";